<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 電話派車
    .abilityGroup__item
      span.abilityGroup__subtitle 叫車紀錄頁面
      BaseAbilityRadioGroup(
        :value="abilityTransactionRecord"
        :disabled="disabled"
        :unreadableAbility="true"
        @handleRadioChange="setAbilityTransactionRecord")
    .abilityGroup__item
      span.abilityGroup__subtitle 派車頁面
      BaseAbilityRadioGroup(
        :value="abilityCallCar"
        :disabled="disabled"
        :unreadableAbility="true"
        @handleRadioChange="setAbilityCallCar")
    .abilityGroup__item
      span.abilityGroup__subtitle 後派單頁面
      BaseAbilityRadioGroup(
        :value="abilitySaveHailBill"
        :disabled="disabled"
        :unreadableAbility="true"
        @handleRadioChange="setAbilitySaveHailBill")
    .abilityGroup__item
      span.abilityGroup__subtitle 客服預約前派單
      BaseAbilityRadioGroup(
        :value="abilitySaveReservation"
        :disabled="disabled"
        :unreadableAbility="true"
        @handleRadioChange="setAbilitySaveReservation")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityTransactionRecord:
        'positionStore/getCurrentAbilityTransactionRecord',
      abilityCallCar: 'positionStore/getCurrentAbilityCallCar',
      abilitySaveHailBill: 'positionStore/getCurrentAbilitySaveHailBill',
      abilitySaveReservation: 'positionStore/getCurrentAbilitySaveReservation',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityTransactionRecord: 'positionStore/setAbilityTransactionRecord',
      setAbilityCallCar: 'positionStore/setAbilityCallCar',
      setAbilitySaveHailBill: 'positionStore/setAbilitySaveHailBill',
      setAbilitySaveReservation: 'positionStore/setAbilitySaveReservation',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupPhoneHailing.vue